// extracted by css-extract-rspack-plugin
export default {"textDanger":"bk65sqRh9h0V1wTg"};